module.exports = __webpack_public_path__ + "static/description-c9c2ddf741fd4960b9b6a11b6e30cca9.jpg";